{
  "label": "Idioma",
  "noResults": "No se encontraron idiomas",
  "searchPlaceholder": "Buscar idioma",
  "names": {
    "en": "English",
    "es-mx": "Español (México)",
    "fr-ca": "Français (Canada)",
    "fr": "Français",
    "pt-br": "Português (Brasil)",
    "pt": "Português",
    "ar": "العربية",
    "pl": "Polski",
    "ru": "Русский",
    "uk": "Українська",
    "hi": "हिन्दी",
    "ms": "Bahasa Melayu",
    "zh": "简体中文",
    "pa": "ਪੰਜਾਬੀ",
    "zh-tw": "繁體中文",
    "ja": "日本語",
    "ko": "한국어",
    "id": "Bahasa Indonesia",
    "th": "ไทย",
    "vi": "Tiếng Việt"
  }
}
